<template>
    <div id="step-3" class="step step-3" :class="{active: activeStep == 3}">
        <div class="line"></div>
        <div class="number">{{ step }}</div>
        <div class="title">{{ title }}</div>
        <mu-paper class="content" :z-depth="1">

            <!-- Escolher entre enviar agora ou agendar -->
            <div class="text-center group-radio-button">
                <mu-flex justify-content="center" align-items="center">
                    <mu-radio v-model="form.send" value="now" label="Enviar Agora"></mu-radio>
                    <mu-radio v-model="form.send" value="schedule" label="Agendar"></mu-radio>
                </mu-flex>
            </div>

            <!-- Agendamento -->
            <mu-row gutter v-if="form.send == 'schedule'">
                <mu-col span="12" lg="6" sm="6">
                    <mu-date-input :date.sync="form.schedule.date" v-model="form.schedule.date" label="Selecione a data *" format="DD-MM-YYYY" :should-disable-date="allowedDates" :date-time-format="options.format" full-width></mu-date-input>
                </mu-col>
                <mu-col span="12" lg="6" sm="6">
                    <mu-date-input v-model="form.schedule.time" label="Selecione o horário *" :interval="true" type="time" clock-type="24hr" view-type="list" full-width></mu-date-input>
                </mu-col>
            </mu-row>

        </mu-paper>
        <mu-paper class="buttons" :z-depth="1">
            <mu-flex justify-content="center" align-items="center">
                <mu-button color="#EEF1F3" textColor="#666" round @click="handlePrev()">
                    <font-awesome-icon icon="chevron-left" class="icon-md icon-margin-left"/>
                    Voltar
                </mu-button>
                <mu-button round @click="validateDateTime()" color="primary">
                    Próximo
                    <font-awesome-icon icon="chevron-right" class="icon-md icon-margin-right"/>
                </mu-button>
            </mu-flex>
        </mu-paper>
    </div>
</template>

<script>
    import moment from 'moment'
    import DateFormatCalendar from '@/helpers/calendar'

    export default {
        name: 'card-campaign',
        props: ['activeStep', 'step', 'title', 'form'],

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                options: {
                    format: DateFormatCalendar
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            data () {
                return moment(this.form.schedule.date).format('YYYY-MM-DD')
            },

            time () {
                return moment(this.form.schedule.time).format('HH:mm')
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Chama o evento handlePrev do elemento pai
             */
            handlePrev () {
                this.$emit('handlePrev')
            },

            /**
             * Chamando o emit para dar sequência no cadastro
             */
            handleNext () {
                this.$emit('handleNext', this.form)
            },

            /**
             * Faz a validação da data de agendamento
             */
            validateDateTime () {
                try {
                    if (this.form.send === 'schedule') {
                        if (!this.form.schedule.date) { throw new Error('Informe a data do agendamento.') }
                        if (!this.form.schedule.time) { throw new Error('Informe o horário do agendamento.') }

                        let date = moment(this.form.schedule.date).format('YYYY-MM-DD')
                        let time = moment(this.form.schedule.time).format('HH:mm')

                        let dateSelected = moment(`${date} ${time}`).format('YYYY-MM-DD HH:mm')
                        let dateNow = moment().format('YYYY-MM-DD HH:mm')

                        if (dateSelected < dateNow) {
                            this.$eventHub.$emit('snackbar', 'error', 'A data de agendamento é inferior a data atual.', false)
                            return
                        }
                    }
                    this.handleNext()
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message)
                }
            },

            /**
             * Verificação de que datas desabilitar no calendário
             */
            allowedDates (date) {
                return moment().diff(date, 'days') > 0 || false
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../../assets/stylus/bootstrap.styl'

    .item
        padding 0

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)

        .item
            padding 0

</style>
